import React, { useState } from "react";
import { Form, Input } from "antd";
import IntlMessages from "@iso/components/utility/intlMessages";
import { renderMessage } from "../../library/helpers/renderInputMessage";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useAuth } from "../../contexts/auth";

function PersonalForm({ data }) {
  const { UpdateUser, UpdatePartner } = useAuth();

  const [updating, setUpdating] = useState({
    name: null,
    email: null,
    tel: null,
  });

  const handleBlur = async (e) => {
    let payload = {};
    let temp = updating;
    const field = e.target.id;
    if (updating[field] === true) {
      temp[field] = "validating";
      setUpdating({ ...updating, ...temp });
      payload[field] = e.target.value;

      if (field === 'tel') {
        await UpdatePartner(payload)
          .then(() => {
            temp[field] = "success";
            setUpdating({ ...updating, ...temp });
          })
          .catch(() => {
            temp[field] = "error";
            setUpdating({ ...updating, ...temp });
          });
      } else {
        await UpdateUser(payload)
          .then(() => {
            temp[field] = "success";
            setUpdating({ ...updating, ...temp });
          })
          .catch(() => {
            temp[field] = "error";
            setUpdating({ ...updating, ...temp });
          });
      }
    }
  };

  return (
    <Form className="account-forms" layout="vertical">
      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.personal.fullname" />}
        hasFeedback
        validateStatus={updating.name}
        help={renderMessage("name", updating)}
        rules={[
          {
            required: true,
            message: (
              <IntlMessages id="page.myAccount.forms.personal.fullname.message" />
            ),
          },
        ]}
      >
        <Input
          id="name"
          defaultValue={data.name}
          prefix={<UserOutlined />}
          size="large"
          onBlur={(e) => handleBlur(e)}
          onInput={(e) => {
            setUpdating({ ...updating, name: true });
          }}
          placeholder="Full name"
        />
      </Form.Item>
      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.personal.email" />}
        hasFeedback
        validateStatus={updating.email}
        help={renderMessage("email", updating)}
        rules={[
          {
            required: false,
            message: (
              <IntlMessages id="page.myAccount.forms.personal.email.message" />
            ),
          },
        ]}
      >
        <Input
          defaultValue={data.email}
          prefix={<LockOutlined />}
          disabled
          size="large"
          readOnly
          type="email"
          placeholder="Email"
        />
      </Form.Item>
      <Form.Item
        label={<IntlMessages id="page.myAccount.forms.personal.phone" />}
        hasFeedback
        validateStatus={updating.tel}
        help={renderMessage("tel", updating)}
        rules={[
          {
            required: true,
            message: (
              <IntlMessages id="page.myAccount.forms.personal.phone.message" />
            ),
          },
        ]}
      >
        <Input
          defaultValue={data.tel}
          id="tel"
          size="large"
          onBlur={(e) => handleBlur(e)}
          onInput={() => {
            setUpdating({ ...updating, tel: true });
          }}
          prefix={<UserOutlined />}
          placeholder={"+00 000 000 000"}
        />
      </Form.Item>
    </Form>
  );
}
export default PersonalForm;
